import styled from "@emotion/styled";
import { Heading } from "react-aria-components";

export const PopupDialogHeading = styled(Heading)`
  color: var(--color-charcoal, #212121);
  font-family: "STK Bureau", Sans-Serif, sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.025em;
`;
